import {
    memo,
    useState,
    useEffect,
    useRef
} from 'react'
import { usePermission } from '@shared/hooks/permissions'
import { useDashboard } from '@app/layouts/dashboard/Provider'

import List from './list/List'
import Refresh from './parts/Refresh'
import Add from './parts/Add'
import Filter from './parts/Filter'
import EasyProvider from '@shared/components/EasyProvider'

export default memo(function Estimations() {
    const [filterQuery, setFilterQuery] = useState({})
    const [instance, setInstance] = useState(null)
    const [formVisibility, setFormVisibility] = useState(false)

    const { setTitle } = useDashboard()
    const { hasPermission } = usePermission()

    useEffect(() => {
        setTitle('المقايسات')
    }, [])

    return (
        <EasyProvider value={{
            instance,
            setInstance,
            formVisibility,
            setFormVisibility,

            filterQuery,
            setFilterQuery
        }}>
            <Filter />
            <List />
            <Refresh />
            {hasPermission('add_estimation') && <Add />}
        </EasyProvider>
    )
})